
import React, { Component } from 'react';
import { Form } from 'react-bootstrap';
import { translate } from "react-i18next";

class Parameter extends Component {

    constructor(props) {
        super(props);
        
    }

   
   
    render() {
        const { t } = this.props;
        return <tr key={this.props.p.key}>
            <td >
                <Form.Check type={"checkbox"} id={`check-api-${this.props.p.key}`} className="primary">
                    <Form.Check.Input type={"checkbox"} name="value" value={this.props.p.value} checked={this.props.p.value === '1'} onChange={() => this.props.handleChange(this.props.p)}/>
                    <Form.Check.Label  >{this.props.p.key}</Form.Check.Label>
                </Form.Check>
            </td>
        </tr>

    }
}

export default translate("translations")(Parameter);